import React, { useEffect, useState } from "react";
import { SoundOutline, CloseOutline } from 'antd-mobile-icons'
import { Button, Checkbox, Divider, Modal, Slider, Space } from "antd-mobile";
import Cookies from "js-cookie";

import scanned from "../media/scanned.wav";
import short from "../media/short.wav";
import even from "../media/agree.wav";
import over from "../media/over.wav";
import not_found from "../media/notfound.wav";
import old from "../media/oldstock.wav";


export default function SoundSettings(props) {

    const [visible, setVisible] = useState(false);

    const getInital = () => {

        if (Cookies.get("bm_sounds")) {
            return JSON.parse(Cookies.get("bm_sounds"))
        } else {
            return {
                scanned: false,
                short: false,
                over: false,
                even: false,
                error: false,
                months: 0
            }
        }

    }

    const [settings, setSettings] = useState(getInital());
    const [months, setMonths] = useState(settings.months);
    // Save to cookies when changed..
    useEffect(() => {
        Cookies.set("bm_sounds", JSON.stringify(settings),  { expires: 365 })
    }, [settings])


    const setAndPlay = (_obj, _key, _value) => {

        let _audio;
        if (_value) {
            switch (_key) {
                case "scanned":
                    try {
                        _audio = new Audio(scanned);
                        _audio.play();
                    } catch (e) { }
                    break;
                case "short":
                    try {
                        _audio = new Audio(short);
                        _audio.play();
                    } catch (e) { }
                    break;
                case "over":
                    try {
                        _audio = new Audio(over);
                        _audio.play();
                    } catch (e) { }
                    break;
                case "even":
                    try {
                        _audio = new Audio(even);
                        _audio.play();
                    } catch (e) { }
                    break;
                case "error":
                    try {
                        _audio = new Audio(not_found);
                        _audio.play();
                    } catch (e) { }
                case "old":
                    try {
                        _audio = new Audio(old);
                        _audio.play();
                    } catch (e) { }
                    break;
            }
        }
        setSettings(_obj);
    }

    const drawSettings = () => {

      
       

        return (
            <div style={{ "textAlign": "left", "padding": "0px" }}>
               
                <div style={{ "textAlign": "center", "opacity": "0.5" }}><p>Configure scanning sounds</p></div>
                <div className="shim" />
                <Space style={{ "gap": "5px" }} direction="vertical">
                    <Checkbox defaultChecked={settings.scanned} onChange={(e) => {
                        setSettings({ ...settings, "scanned": e });
                    }} onClick={(e) => {
                        setAndPlay({ ...settings, "scanned": true }, "scanned", true);
                    }}>&nbsp; Item scanned</Checkbox>
                    <Checkbox defaultChecked={settings.short} onChange={(e) => {
                        setSettings({ ...settings, "short": e });
                    }} onClick={(e) => {
                        setAndPlay({ ...settings, "short": true }, "short", true)
                    }}>&nbsp; Count short</Checkbox>
                    <Checkbox defaultChecked={settings.over} onChange={(e) => {
                        setSettings({ ...settings, "over": e });
                    }} onClick={(e) => {
                        setAndPlay({ ...settings, "over": true }, "over", true)
                    }}>&nbsp; Count over</Checkbox>
                    <Checkbox defaultChecked={settings.even} onChange={(e) => {
                        setSettings({ ...settings, "even": e });
                    }} onClick={(e) => {
                        setAndPlay({ ...settings, "even": true }, "even", true)
                    }}>&nbsp; Count reconciles</Checkbox>
                    <Checkbox defaultChecked={settings.error} onChange={(e) => {
                        setSettings({ ...settings, "error": e });
                    }} onClick={(e) => {
                        setAndPlay({ ...settings, "error": true }, "error", true)
                    }}>&nbsp; Not in inventory</Checkbox>
                    <Checkbox defaultChecked={settings.old} onChange={(e) => {
                        setSettings({ ...settings, "old": e });
                    }} onClick={(e) => {
                        setAndPlay({ ...settings, "old": true }, "old", true)
                    }}>&nbsp; Over {months} month(s) old</Checkbox>
                </Space>
                <Divider />
                <div style={{ "textAlign": "center" }}><p><span style={{ "opacity": "0.5" }}>Scanned is over </span><strong>{months}</strong> <span style={{ "opacity": "0.5" }}>months old</span></p></div>
                <Slider defaultValue={months} onAfterChange={(e) => {
                    setSettings({ ...settings, "months": e });
                    setAndPlay({ ...settings, "months": e }, "months", e)
                    setMonths(e)
                }} max={24} />

            </div>
        )
    }

    return drawSettings()
  
}